import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner__item loading-spinner__item--1" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner__item loading-spinner__item--2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner__item loading-spinner__item--3" }, null, -1)
const _hoisted_5 = { class: "visually-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "loading-spinner loading-spinner--shop",
        "aria-label": _ctx.translate('general.loading')
      }, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.translate('Shop.is-loading')), 1)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}